import HeroImage from "../components/layouts/HeroImage";
import Navigation from "../components/layouts/Navigation";
import Menu from "../components/Menu/Menu";
import Gallery from "../components/Gallery";
import Contacts from "../components/Contacts";
import Footer from "../components/layouts/Footer";
import {useAuth} from "../store/AuthProvider";
import GoToAdminButton from "../components/GoToAdminButton";
import News from "../components/News";
import {Typography} from "@mui/material";
import {useTranslations} from "../store/LanguageProvider";

const HomePage = () => {
    const auth = useAuth();
    const {translations} = useTranslations();

    const onCookiesBtnClickHandler = () => {
        document.querySelector('.cky-btn-revisit').click();
    }

    return <>
        <HeroImage/>
        <Navigation/>
        <News/>
        <Menu/>
        <Gallery/>
        <Contacts/>
        <Typography
            py={1}
            variant='body2'
            textAlign='center'
            fontSize='0.8rem'
            onClick={onCookiesBtnClickHandler}
            sx={{cursor: 'pointer'}}
        >{translations.edit_cookies}</Typography>
        <Footer/>
        {auth.token && <GoToAdminButton />}
    </>
}

export default HomePage;